import { createAppWrap } from '../../create_app_wrap';
import commonMixin from '../../mixins/_common';
import flashMessageMixin from '../../mixins/_flash_messages';
import chromeExtensionMixin from '../../mixins/_chrome_extension';
import modalYahooAuth from '../../components/_modal_yahoo_auth';
import preview from './_preview_component';
import designEdit from './_design_edit_component';

const view = '[data-view="custom_page-edit"]';
const init = () => {
    createAppWrap({
        el: view,
        data () {
            return {
                // 画面表示フラグ(isValidTokenで更新)
                show_disp: false,
            };
        },
        mixins: [
            commonMixin,
            flashMessageMixin,
            chromeExtensionMixin,
        ],
        components: {
            // ヤフーAPIトークン認証チェックコンポーネント
            'modal-yahoo-auth': modalYahooAuth,
            // プレビューコンポーネント
            'preview': preview,
            // デザイン編集コンポーネント
            'design-edit': designEdit,
        },
        mounted: function () {
            // 共通グローバルヘッダ非表示
            this.$_showGlobalHeader(false);
        },
    });
};

if (document.querySelector(view)) {
    init();
}